import React from "react";

export const NoExecutionIcon: () => React.JSX.Element = () => {
  return (
    <svg width="588" height="100" viewBox="0 0 588 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="246" width="96" height="96" rx="48" fill="#E9F3FF"/>
      <path opacity="0.3" fillRule="evenodd" clipRule="evenodd"
        d="M279.62 36.4609L301.96 58.8009H279.62V36.4609ZM311.62 57.1409L293.96 38.8009H311.62V57.1409Z"
        fill="#3A76BA"/>
      <path fillRule="evenodd" clipRule="evenodd"
        d="M276.12 32.94L273 29.82L275.82 27L315.4 66.6L312.58 69.42L305.96 62.8H279.62C277.42 62.8 275.62 61 275.62
        58.8L275.64 34.8C275.64 34.12 275.82 33.5 276.12 32.94ZM279.62 58.8H301.96L279.62
        36.46V58.8ZM295.62 34.8H311.62C313.82 34.8 315.62 36.6 315.62 38.8V58.8C315.62 59.48 315.44 60.1
        315.14 60.66L311.62 57.14V38.8H293.96L285.96 30.8H291.62L295.62 34.8Z"
        fill="#3A76BA"/>
    </svg>
  );
};
